export const UpperLeftGlow = ({ className }: { className?: string }) => {
  return (
    <svg className={className} width="970" height="632" viewBox="0 0 970 632" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_f_1701_117554)">
        <ellipse cx="-540" cy="-33" rx="1010" ry="165" className="fill-violet-500" />
      </g>
      <defs>
        <filter id="filter0_f_1701_117554" x="-2050" y="-698" width="3020" height="1330" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="250" result="effect1_foregroundBlur_1701_117554" />
        </filter>
      </defs>
    </svg>
  )
}
